import { Booking } from '../../../booking/domain/models/booking.model';
import { IPaymentResult } from '../../domain/interfaces/payment-storage.interface';

export class PaymentBookingCompletedEvent {
  readonly type = 'PaymentBookingCompletedEvent';
  readonly occurredAt = new Date();

  constructor(
    public readonly booking: Booking,
    public readonly paymentResult: IPaymentResult,
  ) {}
}
